export default "__VITE_ASSET__CgZVR5fu__"